import React from 'react'

const Footer = () => {
    return (
        <footer className="ocn-footer">
            <div className="ocn-wrap">
                <span>OpenCodeNet · An open dataset of labelled code commits</span>
                <span>A research project by P.K. Medappa, A. Saghafi and S.C. Srivastava</span>
            </div>
        </footer>
    )
}

export default Footer
